import { useEffect, useRef, useState } from 'react';
import { FileText } from 'lucide-react';

const WPM = 150; // conversational presenter pace
const MAX_CHARS = 6000;

export const estimateSeconds = (text) => Math.round(((text || '').trim().split(/\s+/).filter(Boolean).length / WPM) * 60);

export const PresenterScriptPanel = ({ video, onSave }) => {
  const [script, setScript] = useState(video.script || '');
  const timer = useRef(null);
  useEffect(() => { setScript(video.script || ''); }, [video.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const change = (val) => {
    setScript(val);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => onSave(val), 800);
  };
  const secs = estimateSeconds(script);
  const over = secs > 300 || script.length > MAX_CHARS;
  const fmt = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;

  return (
    <section className="ff-card rounded-2xl p-5" data-testid="presenter-script-panel">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-[10px] tracking-[0.2em] uppercase font-semibold text-[#E879F9] flex items-center gap-2"><FileText className="w-3.5 h-3.5" /> 1 · Script</h2>
        <span data-testid="script-estimate" className={`text-[11px] font-mono ${over ? 'text-red-400' : 'text-[#8A8A93]'}`}>
          ~{fmt(secs)} spoken · {script.length.toLocaleString()}/{MAX_CHARS.toLocaleString()} chars
        </span>
      </div>
      <textarea data-testid="presenter-script-input" value={script} onChange={e => change(e.target.value)} rows={12} maxLength={MAX_CHARS + 500}
        placeholder="Hi, I'm Maya, and today I'm going to walk you through…"
        className="ff-input w-full rounded-xl px-4 py-3 text-sm leading-relaxed resize-y min-h-[220px]" />
      <p className="text-[11px] text-[#8A8A93] mt-2">
        {over ? 'Kling Avatar caps at 5 minutes of audio — trim the script.' : 'Write it the way you\'d say it out loud. Punctuation drives the pauses. Max 5 minutes (~750 words).'}
      </p>
    </section>
  );
};
